import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Modal } from 'semantic-ui-react';
import { resetFlaggedState } from '../../../data/questions/actions';
import localization from '../../../localization';

const {
    topic: {
        flagQuestion: {
            successMessage,
            successTitle,
        },
    },
} = localization;

class SuccessModal extends Component {
    state = { open: false };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen) {
            this.open();
        }
    }

    open = () => this.setState({ open: true });
    close = () => {
        this.props.resetFlaggedState();
        this.setState({ open: false });
    }

    render() {
        return (
            <Modal
                basic
                open={this.state.open}
            >
                <Modal.Header>{successTitle}</Modal.Header>
                <Modal.Content>
                    {successMessage}
                </Modal.Content>
                <Modal.Actions>
                    <Button icon="check" content="Ok" onClick={this.close} color="green" inverted />
                </Modal.Actions>
            </Modal>
        );
    }
}

// TODO: remove after UNSAFE method below is refactored
/* eslint-disable react/no-unused-prop-types */
SuccessModal.propTypes = {
    resetFlaggedState: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
};
/* eslint-enable react/no-unused-prop-types */

SuccessModal.defaultProps = {
    isOpen: false,
};

export default connect(
    (_, ownProps) => ownProps,
    dispatch => ({
        resetFlaggedState: () => dispatch(resetFlaggedState()),
    }),
)(SuccessModal);
